<template>
  <div
    class="card-main"
    @click="onClick"
    @mouseover="focusOn"
    @mouseleave="focusOut"
  >
    <div class="inner">
      <!-- <img class="card-img" src="@/assets/button-home-plus.png" /> -->
      <img class="cover-img" src="@/assets/button-plus.png" />
      <div class="card-text">더보기</div>
    </div>
    <div class="focus-ring" v-show="isfocusOn && mouseActivated"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveVue: true,
      isfocusOn: false,
    };
  },
  props: ["cardData", "isFocusedLine"],

  computed: {
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
  },

  methods: {
    onClick() {
      if (this.isfocusOn) {
        this.clickCard();
      }
    },
    clickCard() {
      if (this.cardData.type == "3") {
        this.$router.push({
          name: "league2nd",
          params: {
            name: this.cardData.name,
            gameTypeId: this.cardData.gameDesc.typeId,
            leagueId: this.cardData.id,
            t: new Date().getTime(),
          },
        });
      } else if (this.cardData.type == "4") {
        this.$router.push({
          name: "theme-detail",
          params: {
            title: this.cardData.name,
            themeId: this.cardData.id,
            t: new Date().getTime(),
          },
        });
      } else if (this.cardData.type == "6") {
        this.$router.push({
          name: "program-detail",
          params: {
            title: this.cardData.name,
            programId: this.cardData.id,
            t: new Date().getTime(),
          },
        });
      } else {
        this.$router.push({
          name: "game-detail",
          params: {
            gameId: this.cardData.gameDesc.id,
            t: new Date().getTime(),
          },
        });
      }
      this.focusOut();
    },
    focusOn() {
      if (this.isFocusedLine) {
        this.isfocusOn = true;
      }
    },
    focusOut() {
      this.isfocusOn = false;
    },
  },
};
</script>

<style scoped>
.card-main {
  position: relative;
  display: inline-block;
  margin-right: 20px;
  width: 444px;
  height: 410px;
  /* height: 410px; */
  z-index: 2;
}

.focus-ring {
  position: absolute;
  left: -5px;
  top: -4px;
  height: 410px;
  width: 444px;
  border: solid 4px #eeeeee;
  z-index: 5;
}
.inner {
  width: 444px;
  height: 410px;
  text-align: center;
  background-color: #1e1e1e;
}

.card-img {
  width: 444px;
  height: 399px;
}
.cover-img {
  top: 114px;
  width: 100px;
  height: 100px;
}
.card-text {
  margin-top: 140px;
  top: 12px;
  font-size: 28px;
  color: #ededed;
}

@media all and (min-width:0px) and (max-width:1280px){
  .card-main {
    position: relative;
    display: inline-block;
    margin-right: 20px;
    width: 300px;
    height: 316px;
    z-index: 2;
  }

  .focus-ring {
    position: absolute;
    left: -5px;
    top: -4px;
    width: 308px;
    height: 324px;
    border: solid 4px #eeeeee;
    z-index: 5;
  }
  .inner {
    width: 300px;
    height: 316px;
    text-align: center;
    background-color: #1e1e1e;
  }

  .card-img {
    width: 444px;
    height: 399px;
  }
  .cover-img {
    top: 99.8px;
    width: 64px;
    height: 64px;
  }
  .card-text {
    margin-top: 107.5px;
    top: 12px;
    font-size: 22px;
    color: #ededed;
  }
}
</style>